<div class="waec-page-header">
  <img class="waec-page-header-image" src="/assets/icons/Highighted_Access.svg" alt="Highighted_Access" />
  <h3 class="waec-page-header-text">{{'GENERAL.CERTIFICATE_ACCESS' | translate}}</h3>
</div>

<div class="page-container">
  <!-- PROVISSIONING -->
  <div class="accessing" id="accessing">
    <nz-card class="ant-card-body-main" [nzBordered]="false">
      <div nz-row>
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="16" nzXl="16" class="verification_form">
          <h3 class="waec-card-header-text">{{'PROVISIONING.PROVISION.CARD_TITLE' | translate}}</h3>
          <div class="span-left">
            {{'PROVISIONING.PROVISION.SUBTITLE' | translate}}
          </div>
        </div>
        <div *ngIf="isCandidateNoRecoveryAvailable" class="span-left recovery-intro" nz-col nzXs="24" nzSm="24" nzMd="24"
          nzLg="6" nzXl="6">
          {{'PROVISIONING.PROVISION.FORGOTTEN_CANDIDATE_NUMBER' | translate}} <br />
          {{'PROVISIONING.PROVISION.CLICK_BELOW' | translate}}
          <div>
            <button class="mt-2" (click)="retrieveButton()" nz-button nzType="primary" nzSize="medium">
              {{'PROVISIONING.PROVISION.RECOVERY_BTN' | translate | uppercase}}
            </button>
          </div>
        </div>
      </div>
      <div nz-row>
        <div nz-col nzXs="24" nzSm="24" nzMd="16" nzLg="16" nzXl="16">
          <!-- <nz-alert
            *ngIf="message"
            [nzType]="'error'"
            [nzMessage]="message"
            nzCloseable
            class="mb-lg"
          ></nz-alert> -->
          <form nz-form [formGroup]="accessingForm" (ngSubmit)="confirmInformation()">
            <nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="accessing-form-container">
              <div nz-col class="gutter-row" nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item>
                  <nz-col nzSpan="24">
                    <nz-form-label nzRequired nzFor="candidate_country">{{'GENERAL.SELECT_COUNTRY' |
                      translate}}</nz-form-label>
                    <nz-form-control [nzErrorTip]="'GENERAL.SELECT_COUNTRY' | translate" nzSpan="24">
                      <nz-select formControlName="country" id="candidate_country"
                        [nzPlaceHolder]="'GENERAL.SELECT_COUNTRY' | translate" name="type"
                        [nzCustomTemplate]="countrySelection" nzDisabled>
                        <nz-option *ngFor="let data of countries" [nzValue]="data.code" [nzLabel]="data.name"
                          nzDisabled>
                        </nz-option>
                      </nz-select>
                      <ng-template #countrySelection let-selected>
                        <img class="selected_country" alt="{{ selected.nzLabel }}" src="https://purecatamphetamine.github.io/country-flag-icons/3x2/{{
                            selected.nzValue
                          }}.svg" height="20" width="20" />
                        {{ selected.nzLabel }}
                      </ng-template>
                    </nz-form-control>
                  </nz-col>
                </nz-form-item>
              </div>
              <div nz-col class="gutter-row" nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item>
                  <nz-col nzSpan="24">
                    <nz-form-label nzRequired nzFor="year">{{'GENERAL.EXAM_YEAR' | translate}}</nz-form-label>
                    <nz-form-control [nzErrorTip]="'GENERAL.PLEASE_SELECT_EXAM_YEAR' | translate">
                      <nz-select [nzShowSearch]="true" formControlName="year" name="year" id="year"
                        [nzPlaceHolder]="'GENERAL.ENTER_EXAM_YEAR' | translate"
                        (ngModelChange)="chooseDiet($event); onEnableCheckbox()">
                        <nz-option *ngFor="let o of dietYears" [nzLabel]="o" [nzValue]="o"></nz-option>
                      </nz-select>
                    </nz-form-control>
                  </nz-col>
                </nz-form-item>
              </div>
            </nz-row>
            <nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
              <div nz-col class="gutter-row" nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
                <nz-form-item>
                  <nz-col nzSpan="24">
                    <nz-form-label nzRequired nzFor="exam_type">{{'GENERAL.SELECT_EXAM_TYPE' |
                      translate}}</nz-form-label>
                  </nz-col>
                  <nz-col nzSpan="24">
                    <nz-form-control [nzErrorTip]="'GENERAL.PLEASE_SELECT_EXAM_YEAR' | translate">
                      <nz-select (click)="choosenDiet()" (ngModelChange)="onEnableCheckbox()" nzName="radiogroup"
                        formControlName="exam_type" [nzPlaceHolder]="'GENERAL.SELECT_AN_EXAM_TYPE' | translate"
                        id="exam_type" name="exam_type">
                        <nz-option *ngFor="let exam of availableExamDiets" [nzLabel]="exam" [nzValue]="exam">
                        </nz-option>
                      </nz-select>
                    </nz-form-control>
                  </nz-col>
                </nz-form-item>
              </div>
              <div nz-col class="gutter-row" nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
                <nz-form-item>
                  <nz-col nzSpan="24">
                    <nz-form-label nzFor="dob">{{'GENERAL.DATE_OF_BIRTH' | translate}} &nbsp;
                      <span class="optional">({{'GENERAL.OPTIONAL' | translate}})</span>
                    </nz-form-label>
                    <nz-form-control [nzErrorTip]="'GENERAL.SELECT_DOB' | translate">
                      <nz-date-picker class="w-100" nzPlaceHolder="{{'GENERAL.SELECT_DATE' | translate}}"
                        [nzDisabledDate]="disabledDate_of_Birth" formControlName="dob" id="dob"></nz-date-picker>
                    </nz-form-control>
                  </nz-col>
                </nz-form-item>
              </div>
            </nz-row>
            <nz-row class="candidate-no-row mb-0" [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
              <div nz-col class="gutter-row" nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
                <nz-form-item>
                  <div nz-col nzSpan="24">
                    <nz-form-label nzRequired nzFor="candidate_no">{{'GENERAL.ENTER_CANDIDATE_NUMBER' |
                      translate}}</nz-form-label>

                    <nz-form-control [nzErrorTip]="'GENERAL.INVALID_CANDIDATE_NUMBER' | translate">
                      <nz-input-group>
                        <input nz-input (ngModelChange)="onEnableCheckbox()" name="candidate_no" id="candidate_no"
                          formControlName="candidate_no" type="text" />
                      </nz-input-group>

                      <ng-container *ngIf="
                          accessingForm?.hasError('candidateNumberExamTypeMismatch') &&
                          candidate_no.touched &&
                          year.valid &&
                          exam_type.valid &&
                          confirm_candidate_no.valid
                        ">
                        <div class="error-text">
                          {{'GENERAL.CANDIDATE_NUM_EXAM_TYPE_MISMATCH' | translate}}.
                        </div>
                      </ng-container>
                    </nz-form-control>

                  </div>
                  <div *ngIf="isCandidateNoRecoveryAvailable" class="view-recovered-candidate-no">
                    <img class="recovery-icon" src="./assets/icons/Recovery.svg" alt="" />
                    <a class="recovered-candidates row-gutter" (click)="openRecoveredCandidateNumberModal()">
                      {{'PROVISIONING.PROVISION.VIEW_RECOVERED' | translate}}
                    </a>
                  </div>
                </nz-form-item>
              </div>
              <div nz-col class="gutter-row" nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
                <nz-form-item>
                  <div nz-col nzSpan="24">
                    <nz-form-label nzRequired nzFor="confirm_candidate_no">{{'GENERAL.CONFIRM_CANDIDATE_NUMBER' |
                      translate}}</nz-form-label>
                    <nz-form-control [nzErrorTip]="'GENERAL.CONFIRM_CANDIDATE_NUM_MISMATCH' | translate">
                      <nz-input-group>
                        <input nz-input (ngModelChange)="onEnableCheckbox()" name="confirm_candidate_no"
                          id="confirm_candidate_no" formControlName="confirm_candidate_no" type="text"
                          (paste)="copynpaste()" (drop)="copynpaste()" autocomplete="{{ autocomplete }}" />
                      </nz-input-group>
                    </nz-form-control>
                  </div>
                </nz-form-item>
              </div>
            </nz-row>
            <div nz-col nzSpan="24"></div>
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'GENERAL.VERIFY_INFO' | translate">
                <label nz-checkbox [nzDisabled]="isDisableCheckbox" (ngModelChange)="checkButton()"
                  formControlName="validData">
                  <span class="verify_info">{{'GENERAL.VERIFY_INFO' | translate}}</span>
                </label>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-col nzSpan="17">
                <nz-form-control>
                  <button nz-button nzType="primary" [nzLoading]="loading" [disabled]="checkFormValidity()"
                    nzSize="large">
                    {{'GENERAL.ACCESS_CERTIFICATE' | translate | uppercase}}
                  </button>
                </nz-form-control>
              </nz-col>
            </nz-form-item>
          </form>
        </div>
      </div>
    </nz-card>
  </div>
</div>


<!-- USER VERIFICATION -->
<app-user-verification *ngIf="userInformationVerification" (successResponse)="accessingFormSubmit()"
  (closeModal)="cancelMeansofIdentificationModal($event)" (fetchCertificate)="fetchCertificate()"
  [step]="userInformationWindowStep" [year]="Year" [actions]="actions"></app-user-verification>

<!-- MODE OF PAYMENT Information -->
<app-payment *ngIf="paymentModal" (closeModal)="cancelPaymentOptionsModal()" (confirmSubmit)="initiateWallet($event)"
  [action]="services.ACCESS" [Cost]="accessCost"></app-payment>

<!-- Wallet Credit -->
<nz-modal [nzStyle]="{ top: '20px' }" [nzMask]="true" nzMaskClosable="false" nzWidth="400px" nzClosable="true"
  [(nzVisible)]="walletCreditModal" [nzTitle]="'GENERAL.FUND_WALLET' | translate"
  [nzContent]="modalContentbillingpayment" (nzOnCancel)="cancelmodalContentbillingpayment()">
  <ng-template #modalContentbillingpayment>
    <app-billing-modal (successResponse)="initiateFundingWallet()" [Cost]="accessCost"></app-billing-modal>
  </ng-template>
  <div *nzModalFooter></div>
</nz-modal>

<!-- TERMS AND CONDITION MODAL -->
<nz-modal [nzStyle]="{ top: '20px' }" [nzMask]="true" nzWidth="600px" nzMaskClosable="false" nzClosable="false"
  [nzTitle]="'GENERAL.TERM_OF_USE' | translate" [nzContent]="modalContent" (nzOnCancel)="dismissModal()"
  (nzOnOk)="agreeToTerms()" [nzOkText]="'GENERAL.AGREE' | translate | uppercase"
  [nzOkDisabled]="enableTermsConditionsAgreeButton">
  <ng-template #modalContent>
    <div>
      <app-termsconditions (buttonEnable)="enableTermsConditions($event)"></app-termsconditions>
    </div>
  </ng-template>
</nz-modal>


<!-- OTP Modal  -->
<nz-modal [nzMask]="true" nzMaskClosable="false" [(nzVisible)]="otpModal" [nzTitle]="modalotpTitle"
  [nzContent]="modalotpContent" [nzFooter]="null" (nzOnCancel)="cancelOtpModal()" nzCentered="true">
  <ng-template #modalotpTitle>
    {{ accessFormData ? "NOTIFICATION!" : "OOPS!" }}
  </ng-template>

  <ng-template #modalotpContent>
    <p>
      {{ message }}
    </p>
    <form nz-form [formGroup]="otpFormGroup" (submit)="submitOtp()">
      <nz-form-item *ngIf="accessFormData">
        <nz-col nzSpan="24">
          <nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="16" nzXl="16">
            <nz-form-label nzFor="otp">{{'GENERAL.ENTER_CODE' | translate}}</nz-form-label>
          </nz-col>
          <nz-col nzSpan="24">
            <nz-form-control nzErrorTip="Please enter the Code">
              <input nz-input name="otp" id="otp" formControlName="otp" nzPlaceHolder="Enter Code" />
            </nz-form-control>
          </nz-col>
        </nz-col>
      </nz-form-item>
      <nz-form-item *ngIf="!accessFormData">
        <nz-col nzSpan="24">
          <button nz-button nzType="primary" [disabled]="loading" [nzLoading]="loading" (click)="showNotify()">
            {{'PROVISIONING.CERTIFICATES.REQUEST_CONSENT' | translate}}
          </button>
        </nz-col>
        <br />
        <br />
        <nz-col nzSpan="24">
          <p>
            <a routerLink="{{pageRoutes?.enquiry?.openTicket}}/{{ ticketCategory }}" class="log_ticket">Lodge a
              Complaint</a>
          </p>
        </nz-col>
      </nz-form-item>
      <nz-form-item class="mt-2 mb-2" *ngIf="accessFormData">
        <nz-col nzSpan="24">
          <nz-form-control>
            <button nz-button nzType="secondary" (click)="cancelOtpModal()">
              {{'GENERAL.CANCEL' | translate}}
            </button>
            <button nz-button nzType="primary" [disabled]="loading" [nzLoading]="loading">
              {{'PROVISIONING.PROVISION.VERIFY' | translate}}
            </button>
          </nz-form-control>
        </nz-col>
      </nz-form-item>
      <nz-form-item class="mb-2 mt-2" *ngIf="accessFormData?.codeExpiryTime">
        <n-col nzSpan="24">
          <p class="text-xs ion-text-center mt-4">
            <i>{{'PROVISIONING.PROVISION.CODE_EXPIRY' | translate}} {{ accessFormData?.codeExpiryTime }}</i>
          </p>
        </n-col>
      </nz-form-item>
    </form>
  </ng-template>
</nz-modal>

<!-- RECOVERED CANDIDATE NUMBER MODAL -->
<digicert-recovered-candidate-number-modal *ngIf="viewRecoveredCandidateModal"
  (setCandidateDetail)="setCandidateNo($event)"
  (closeModal)="closeRecoveredCandidateModal($event)"></digicert-recovered-candidate-number-modal>

<!-- SERVICE CHARGE / INFORMATION CONFIRMATION MODAL -->
<digicert-service-charge *ngIf="userInformationModal" [candidateInformationForm]="candidateInformation"
  [serviceCharge]="serviceCharge" [costInUnit]="accessCost" [feature]="services.ACCESS"
  (closeModal)="closeConfirmInformation()" (makePayment)="submit()"></digicert-service-charge>

<!-- TERMS MODAL -->
<digicert-process-steps *ngIf="termsConditionsModal" [feature]="services.TERMS" [service]="services.ACCESS"
  (closeModal)="dismissModal()" (acceptTerms)="agreeToTerms()"></digicert-process-steps>

<!-- PROCESS FLOW MODAL -->
<digicert-process-steps *ngIf="processStepsModal" [feature]="services.ACCESS" [serviceCharge]="serviceCharge"
  [costInUnit]="accessCost" [userType]="userTypes.USER | lowercase" [candidateInformation]="candidateInformation"
  (successfulFlow)="confirmPayment()" (withdrawFromWallet)="accessingFormSubmit()"
  (closeModal)="closeProcessStepsModal($event)"></digicert-process-steps>

<!-- RECOVER EXAM NUMBER MODAL -->
<app-recoveryterms *ngIf="recoverExamNoModal" (proceed)="openExamNoRecoveryPage()"
  (closeModal)="dismissRecoveryModal()"></app-recoveryterms>

<!-- EXAM COUNTRY SETUP MODAL -->
<app-exam-country-setup *ngIf="examCountrySetupModal"
  (closeModal)="closeExamCountrySetupModal()"></app-exam-country-setup>